document.addEventListener("DOMContentLoaded", () => {
  const revealOptions = {
    root: null,
    threshold: 0.15, 
    rootMargin: "0px 0px -50px 0px" 
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); 
      }
    });
  }, revealOptions);

  const revealElements = document.querySelectorAll('.reveal-up, .reveal-scale');
  revealElements.forEach(el => revealObserver.observe(el));
});